import { render } from "./AddGroup.vue?vue&type=template&id=0f457978"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__